// src/utils/preciseCalculator.js
function getDecimalLength(num) {
  const decimalPart = num.toString().split(".")[1];
  return decimalPart ? decimalPart.length : 0;
}

function convertToInt(num1, num2) {
  const maxLength = Math.max(getDecimalLength(num1), getDecimalLength(num2));
  const power = Math.pow(10, maxLength);
  return {
    int1: Math.round(num1 * power),
    int2: Math.round(num2 * power),
    power: power,
  };
}

export const $calc = {
  /**
   * 精确加法
   * @param {number} num1 - 第一个加数
   * @param {number} num2 - 第二个加数
   * @returns {number} 精确的和
   */
  jiaFa(num1, num2) {
    const { int1, int2, power } = convertToInt(num1, num2);
    return (int1 + int2) / power;
  },

  /**
   * 精确减法
   * @param {number} num1 - 被减数
   * @param {number} num2 - 减数
   * @returns {number} 精确的差
   */
  jianFa(num1, num2) {
    const { int1, int2, power } = convertToInt(num1, num2);
    return (int1 - int2) / power;
  },

  /**
   * 精确乘法
   * @param {number} num1 - 第一个乘数
   * @param {number} num2 - 第二个乘数
   * @returns {number} 精确的积
   */
  chengFa(num1, num2) {
    const { int1, int2, power } = convertToInt(num1, num2);
    return (int1 * int2) / (power * power);
  },

  /**
   * 精确除法
   * @param {number} num1 - 被除数
   * @param {number} num2 - 除数
   * @returns {number} 精确的商
   * @throws {Error} 当除数为0时抛出错误
   */
  chuFa(num1, num2) {
    const { int1, int2 } = convertToInt(num1, num2);
    if (num2 === 0) throw new Error("Division by zero");
    return int1 / int2;
  },
};
